// NPM
import * as React from "react"
import { graphql } from "gatsby"
import _ from "lodash"

// Components
import Layout from "src/layouts/fr"
import DecisionTools from "src/components/pages/DecisionTools/DecisionTools"

const DecisionToolsPageFr = ({ location, data }) => {
  const topNav = data.topNav
  const sections = _.get(data, `decisionToolsPage.sections`, [])
  const bottomNav = data.bottomNav
  const socialMedia = _.get(data, `socialMedia.nodes`, [])

  return (
    <Layout
      location={location}
      topNav={topNav}
      page={data.decisionToolsPage}
      bottomNav={bottomNav}
      socialMedia={socialMedia}
    >
      <DecisionTools sections={sections} />
    </Layout>
  )
}

export default DecisionToolsPageFr

export const query = graphql`
  query DecisionToolsPageFrQuery($id: String) {
    topNav: strapiTopNav(locale: { eq: "fr" }) {
      ...topNavContent
    }

    decisionToolsPage: strapiPage(id: { eq: $id }) {
      ...pageInformation
    }

    bottomNav: strapiBottomNav(locale: { eq: "fr" }) {
      ...bottomNavContent
    }

    socialMedia: allStrapiSocialMedia(filter: { locale: { eq: "fr" } }) {
      nodes {
        ...socialMedia
      }
    }
  }
`
